import { Item } from './../share/store';
import { EntityModel, LineModel, ModelOf, ModelType } from './model';
import { v4 as uuidv4 } from 'uuid';
import { Observable, BehaviorSubject, interval, Subject, noop } from 'rxjs';
import { Vector3, Vector2 } from 'three';
import { TEST_MODELS } from './entities.repository';
import { map, switchMap, filter, first, share } from 'rxjs/operators';
import { Optional } from '@angular/core';
import { StoreByArray } from '../share/store';
import { CanvasComponent } from './components/canvas/canvas.component';
import { sequenceDummyGrayImage2 } from '../image-store/http-image-loader/image.debug.repository';


export class EntitiesService {
  public nextImage$ = new Subject<void>();
  private models = new StoreByArray<{ id: string }, Item<EntityModel>>();

  constructor(@Optional() canvas: CanvasComponent) {
    TEST_MODELS.forEach((x) =>
      this.models.insert({ id: x.id, ...x.model }).subscribe()
    );
  }
  currentModels(): Item<EntityModel>[] {
    return this.models.currentState();
  }
  getModel$<K extends ModelType>(
    type: K,
    id: string
  ): Observable<Item<ModelOf<K>>> {
    return this.models.get$({ id }).pipe(
      filter((x) => x.type === type),
      map((x: any) => x as Item<ModelOf<K>>)
    );
  }

  addModel(model: EntityModel, id?: string): Observable<string> {
    console.log('add model', model);
    let result: string;
    if (id === undefined) {
      result = uuidv4();
    } else {
      result = id;
    }
    return new Observable<string>((obs) => {
      this.models
        .insert({ id: result, ...model })
        .subscribe(noop, obs.error, () => obs.next(result));
    }).pipe(
      first(),
      share()
    );
  }

  update(item: Item<EntityModel>): Observable<never> {
    return this.models.update(item);
  }

  testLine() {
    function createLine(x: number): LineModel {
      return new LineModel(new Vector3(-10, x, 0), new Vector3(10, x, 0));
    }
    return this.addModel(createLine(0)).pipe(
      switchMap((id) =>
        interval(100).pipe(
          map((x) => Math.sin(x / 20) * 30),
          map((x) => {
            return {
              id,
              ...createLine(x),
            };
          }, switchMap((item: Item<LineModel>) => this.update(item)))
        )
      )
    );
  }

  testSequenceImage() {
    return sequenceDummyGrayImage2(
      new Vector2(10, 20),
      new Vector2(10, 20),
      new Vector2(0, 0),
      this.nextImage$
    );
  }

  testWebSocketLine() {}

  // testSlicedPlane() {
  //   const plane$ = interval(100).pipe(
  //     map(x => Math.sin(x / 20) * 30),
  //     map(
  //       x =>
  //         new Plane2Model(new BoundingBox2FromLRTB(-10, 10, -30, -30 + x), {
  //           r: new Uint8Array([255]),
  //           g: new Uint8Array([255]),
  //           b: new Uint8Array([255]),
  //           shape: new Vector2(1, 1)
  //         })
  //     )
  //   );
  //   return this.requireModel(plane$);
  // }
}
